import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { ParticipanteLicitacao } from "./participante-licitacao";

export class ItemLicitacao extends ModelSagresDatatable {
  IdItemLicitacao: number;
  IdLicitacao: number;
  DeItemMatServ: string;
  DeUnidadeMedida: string;
  QtItemMatServ: number;
  VlUnitarioEstimado: number;
  NmMarcaItemMatServ: string;
  VlUnitarioLicitado: number;
  NuSequencialItemLote: number;

  IdParticipanteLicitacao: number;
  TemVencedor: boolean;
  VlTotalEstimado: number;

  //estes dados não vêm no dto
  NuSequencialItem: number;
  VlTotalLicitado: number;

  //estes atributos são de itens de um lote
  IdItemLoteLicitacao: number;
  IdLoteLicitacao: number;

  //este a api envia pra sinalizar se falta preencher algo no lote
  IsItemPreenchido: boolean;
  IdParticipanteLicitacaoNavigation: ParticipanteLicitacao;

  //relacionamento utilizado em itens de dispensas e inexigibilidades
  Vencedores?: any[];

  //transients / not mapped
  modoEdicao = false;
  novaDeItemMatServ: string;
  novaUn: string;
  novoValorUnit: number;
  novaQtde: number;
  novaMarca: string;
  loading = false;

  constructor(original?: ItemLicitacao) {
    super();
    if (original) {
      this.IdItemLicitacao = original.IdItemLicitacao;
      this.IdParticipanteLicitacao = original.IdParticipanteLicitacao;
      this.IdLicitacao = original.IdLicitacao;
      this.IdLoteLicitacao = original.IdLoteLicitacao;
      this.IdItemLoteLicitacao = original.IdItemLoteLicitacao;
    }
  }

  /**
   * Retorna o nome do credor de um item pertencente a uma dispensa/inex, se houver array de vencedores.
   * @since 20230830
   */
  nomeCredor(): string {
    if (this.Vencedores && this.Vencedores.length > 0)
      return this.Vencedores[0].Vencedor;
    return "";
  }

  //valida descrição do item, qtd, un medida e valor estimado unitário
  //novaDeItemMatServ, novaQtde, novaUn, novoValorUnit
  isPreenchido(): boolean {
    const isDadosValidos =
      this.isValid(this.novaDeItemMatServ) &&
      this.isValid(this.novaQtde) &&
      this.isValid(this.novaUn) &&
      this.isValid(this.novoValorUnit);
    return isDadosValidos;
  }
}
